import React, { useEffect, useState } from 'react';
import { Icon, SelectInput, Button } from '@sabre/spark-react-core';
import { func, array } from 'prop-types';
import { ToastContainer } from 'react-toastify';
import {
   DAILY_HOURS,
   SATURDAY_HOURS,
   SUNDAY_HOURS,
   WEEK_DAYS,
} from '../../../utils/constants';
import { NOTIFICATION_MESSAGES } from '../../../utils/notification-messages.js';
import { toastWarn } from '../../../utils/toasts.js';
import MultiSelect from '../../multi-select/multi-select.jsx';

const ScheduleDetails = ({
   handleSchedulePopupClose,
   handleSelectSchedule,
   rowData,
}) => {
   const [scheduleDetailsConfig, setScheduleDetailsConfig] = useState({
      selectedDay: '',
      selectedHours: [],
      scheduleRecord: rowData ? rowData : [defaultDay],
   });
   const defaultDay = {
      dayOfWeek: WEEK_DAYS[0].value,
      hours: [],
   };
   useEffect(() => {
      setScheduleDetailsConfig({
         ...scheduleDetailsConfig,
         scheduleRecord: rowData ? rowData : [defaultDay],
      });
   }, []);
   const handleScheduleDayChanged = (selectedDay, index) => {
      const updatedRecord = scheduleDetailsConfig.scheduleRecord;
      const isSameDay = updatedRecord.some(
         (record) => record.dayOfWeek === selectedDay
      );
      if (selectedDay === WEEK_DAYS[0].value || isSameDay) return;
      else {
         const updatedRecord = scheduleDetailsConfig.scheduleRecord;
         updatedRecord[index].dayOfWeek = selectedDay;
         setScheduleDetailsConfig({
            ...scheduleDetailsConfig,
            scheduleRecord: updatedRecord,
         });
      }
   };
   const handleHourSelectionsChange = (selectedHoursDetails, index) => {
      const updatedRecord = scheduleDetailsConfig.scheduleRecord;
      updatedRecord[index].hours = selectedHoursDetails.map(
         (record) => record.value
      );
      setScheduleDetailsConfig({
         ...scheduleDetailsConfig,
         scheduleRecord: updatedRecord,
      });
   };
   const handleRecordAdd = (selectedIndex) => {
      const updatedRecord = scheduleDetailsConfig.scheduleRecord;
      if (
         updatedRecord[selectedIndex]?.dayOfWeek !== WEEK_DAYS[0]?.value &&
         updatedRecord[selectedIndex]?.hours.length > 0
      ) {
         updatedRecord.push(defaultDay);
         setScheduleDetailsConfig({
            ...scheduleDetailsConfig,
            scheduleRecord: updatedRecord,
         });
      } else if (updatedRecord[selectedIndex]?.dayOfWeek === WEEK_DAYS[0]?.value)
         toastWarn(NOTIFICATION_MESSAGES.DAY_VALIDATION);
      else if (updatedRecord[selectedIndex]?.hours.length === 0)
         toastWarn(NOTIFICATION_MESSAGES.HOUR_VALIDATION);
   };
   const handleRecordDelete = (selectedIndex) => {
      const updatedRecord = scheduleDetailsConfig.scheduleRecord;
      updatedRecord.splice(selectedIndex, 1);
      setScheduleDetailsConfig({
         ...scheduleDetailsConfig,
         scheduleRecord: updatedRecord,
      });
   };
   const handleScheduleSelection = () => {
      const isIncompleteDays = scheduleDetailsConfig.scheduleRecord.some(
         (record) => record.dayOfWeek === WEEK_DAYS[0].value
      );
      const isIncompleteHours = scheduleDetailsConfig.scheduleRecord.some(
         (record) => record.hours.length === 0
      );
      if (isIncompleteDays) {
         toastWarn(NOTIFICATION_MESSAGES.DAY_VALIDATION);
         return;
      }
      if (isIncompleteHours) {
         toastWarn(NOTIFICATION_MESSAGES.HOUR_VALIDATION);
         return;
      }
      handleSelectSchedule(scheduleDetailsConfig.scheduleRecord);
   };
   const handleHoursConfiguration = (dayOfWeek) => {
      switch (dayOfWeek) {
         case WEEK_DAYS[7].value:
            return SATURDAY_HOURS;
         case WEEK_DAYS[8].value:
            return SUNDAY_HOURS;
         default:
            return DAILY_HOURS;
      }
   };
   return (
      <>
         <ToastContainer autoClose={3000} hideProgressBar theme='colored' />
         {scheduleDetailsConfig.scheduleRecord.map(
            (scheduleRow, index, data) => {
               return (
                  <div className='spark-flex spark-pad-1' key={index}>
                     <SelectInput
                        name='schedule-days'
                        data-testid='schedule-day-test-id'
                        options={WEEK_DAYS}
                        onChange={(event, value) =>
                           handleScheduleDayChanged(value, index)
                        }
                        value={scheduleRow?.dayOfWeek}
                        required={true}
                     />
                     <div className='col-lg-6'>
                        <MultiSelect
                           name='multi select'
                           data-testid='schedule-hours-test-id'
                           selectedValues={scheduleRow?.hours || []}
                           multiSelectOnChangeHandler={(values) =>
                              handleHourSelectionsChange(values, index)
                           }
                           options={handleHoursConfiguration(scheduleRow?.dayOfWeek)}
                           placeHolder=''
                           className='multi-select-input max-row-width'
                           showLabel={false}
                           enableSelectAll={false}
                           showSearch={false}
                        />
                     </div>
                     <div className='col-lg-2 spark-flex spark-pad-l-0'>
                        {index === data.length - 1 && data.length < 8 && (
                           <Icon
                              name='math-add-circle'
                              data-testid='schedule-add-test-id'
                              className='spark-flex spark-align-items-center spark-pad-l-1 fav-pointer spark-success'
                              size='md'
                              style='fill'
                              onClick={() => handleRecordAdd(index)}
                           />
                        )}
                        {index !== 0 && (
                           <Icon
                              name='math-subtract-circle'
                              data-testid='schedule-delete-test-id'
                              className='spark-flex spark-align-items-center spark-pad-l-1 fav-pointer spark-danger'
                              size='md'
                              style='fill'
                              onClick={() => handleRecordDelete(index)}
                           />
                        )}
                     </div>
                  </div>
               );
            }
         )}
         <div className='spark-flex fav-center spark-pad-t-2 spark-pab-b-2'>
            <Button
               className='spark-btn-group-primary spark-mar-r-1'
               data-testid='schedule-select-test-id'
               size={Button.SIZE.SMALL}
               primary={true}
               onClick={() => handleScheduleSelection()}
            >
               SELECT
            </Button>
            <Button
               className='spark-btn-group-secondary select-button-cancel'
               data-testid='schedule-cancel-test-id'
               size={Button.SIZE.SMALL}
               secondary={true}
               onClick={() => handleSchedulePopupClose()}
            >
               CANCEL
            </Button>
         </div>
      </>
   );
};

ScheduleDetails.propTypes = {
   handleSchedulePopupClose: func,
   handleSelectSchedule: func,
   rowData: array,
};
export default ScheduleDetails;
